"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigDecimal = void 0;
var BigDecimal = /** @class */ (function () {
    function BigDecimal(num, scale) {
        this.scale = 8;
        if (typeof num === 'string') {
            num = parseFloat(num);
        }
        if (scale !== undefined) {
            this.scale = scale;
        }
        this._num = num;
    }
    BigDecimal.prototype.getScale = function () {
        var a = this._num.toString().split('.');
        if (a.length > 1) {
            return a[1].length;
        }
        return 0;
    };
    Object.defineProperty(BigDecimal.prototype, "intCompact", {
        get: function () {
            return this._num * Math.pow(10, this.scale);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BigDecimal.prototype, "stringCache", {
        get: function () {
            var float = this.intCompact.toString();
            var repeat = 0;
            if (this.scale > float.length) {
                repeat = this.scale - float.length;
            }
            var zeros = '0'.repeat(repeat);
            return Math.floor(this._num) + "." + zeros + float;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BigDecimal.prototype, "num", {
        get: function () {
            return this._num;
        },
        enumerable: false,
        configurable: true
    });
    BigDecimal.prototype.multiply = function (x) {
        return new BigDecimal(this.num * this._numValue(x));
    };
    BigDecimal.prototype.setScale = function (newScale, roundingMode) {
        if (newScale === void 0) { newScale = this.scale; }
        if (roundingMode === void 0) { roundingMode = BigDecimal.ROUND_DOWN; }
        var precision = Math.pow(10, newScale + 1);
        var value = this.num * precision;
        value = roundingMode === BigDecimal.ROUND_UP ? Math.ceil(value) : Math.floor(value);
        value = value / precision;
        return new BigDecimal(value);
    };
    BigDecimal.prototype.pow = function (x) {
        return new BigDecimal(Math.pow(this.num, this._numValue(x)));
    };
    BigDecimal.prototype.valueOf = function () {
        return this.num;
    };
    BigDecimal.prototype.unscaledValue = function () {
        return Math.trunc(this.intCompact);
    };
    BigDecimal.prototype._numValue = function (x) {
        if (x instanceof BigDecimal) {
            x = x.num;
        }
        return x;
    };
    // за место Math.pow
    BigDecimal.pow = function (a, b) {
        var n = b < 0 ? b * -1 : b;
        var z = 1;
        for (var i = 0; i < n; i += 1) {
            z *= a;
        }
        return b < 0 ? 1 / z : z;
    };
    BigDecimal.ROUND_UP = 1;
    BigDecimal.ROUND_DOWN = 2;
    return BigDecimal;
}());
exports.BigDecimal = BigDecimal;
